import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DEVICES } from '@app/configs/app-settings.config';
import { supportedBrowser } from '@app/core/helpers/utils';
import { CommonService } from '@app/core/services/common.service';
import { SESSION_CONST } from '../../share/session.constant';

@Component({
  selector: 'app-device-permission-dialog',
  templateUrl: './device-permission-dialog.component.html',
  styleUrls: ['./device-permission-dialog.component.scss']
})
export class DevicePermissionDialogComponent implements OnInit {
  device: string = DEVICES.both();
  isInstruction = false;
  constructor(public readonly dialogRef: MatDialogRef<DevicePermissionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: any,
    public readonly commonService: CommonService) { }

  /**
   * initiate component
   */
  ngOnInit(): void {
    try {
      if (this.data) {
        if (this.data === SESSION_CONST.DEVICE_INSTRUCTION) {
          this.isInstruction = true;
        }
        else {
          this.device = this.data;
        }
      }
    } catch { }
  }
  /**
   * Close dialog box
   */
  closeDailog() {
    this.dialogRef.close();
  }

  /**
   * show browser is latest of supported
   */
  async checkBrowserLatest() {
    const browserinfo = await supportedBrowser();
    let msg = ''
    if (browserinfo.supported) {
      msg = 'You have compatible version of the browser'
    }
    else {
      msg = 'You don`t have compatible version of the browser'
    }
    this.commonService.showSnakeBar(msg)
  }
}
